import React ,{ useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import LinkList from '../components/LinkList';

const Categorys = () => {

  const { category } = useParams(); // URLからcategoryパラメータを取得
  const [categories, setCategories] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    // APIのエンドポイントを指定
    fetch('/req_api/categories.php') 
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // 取得したJSONデータをstateにセット
        setCategories(data);
      })
      .catch(error => {
        setError(error);
        console.error('Error fetching categories:', error);
      });
  }, []);
  

  if (error) {
    return <div>エラーが発生しました: {error.message}</div>;
  }

  const categoryLabel = categories[category] || 'カテゴリ不明';

  return (
    <main>
      <section id="category">
        <div id="category_inner">
          <h2>{categoryLabel}</h2>
          <LinkList />
        </div>
      </section>
    </main>
  );
};

export default Categorys;